import { noop } from 'rxjs';
import { NULL_SERVICE, Service } from '../base/service';

export interface UndoService extends Service {
  commitLastSnapshot(): void;
  takeAndCommitSnapshot(): void;

  pauseTakingSnapshots(): () => void;
}

export const NULL_UNDO_SERVICE: UndoService = {
  ...NULL_SERVICE,
  commitLastSnapshot: noop,
  takeAndCommitSnapshot: noop,
  pauseTakingSnapshots: () => noop,
};
